const TYPES_OF_SLIDES = {
  BIO_WITH_QUOTE_AND_IMAGE: "slides.bio-with-quote-and-image",
  FULLSCREEN_FLYOVER_MAP: "slides.fullscreen-flyover-map-with-description",
  STORY_WITH_IMAGE_AND_MAP: "slides.story-with-image-and-map",
  VIDEO_SLIDE: "slides.video-slide",
};

export default TYPES_OF_SLIDES;
